"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yellow = void 0;
exports.yellow = {
    c10: '#312400',
    c20: '#4C3900',
    c30: '#684F00',
    c40: '#866600',
    c50: '#9B7700',
    c60: '#B58B00',
    c70: '#D5A400',
    c80: '#FCCE74',
    c90: '#FFEED6',
    c100: '#FFFFFF',
};
//# sourceMappingURL=yellow.js.map